import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InserimentoSocietaComponent } from './pages/components/inserimento-societa/inserimento-societa-form.component';
import { SocietaListComponent } from './pages/components/societa-list/societa-list.component';
import {ConfirmModalComponent} from '../../../core/components/dialog/components/confirm-modal/confirm-modal.component';
import { DynamicFormModule } from 'src/app/core/components/dynamic-form/dynamic-form.module';
import {GestionesocietaComponent} from './pages/company-management/gestionesocieta.component';
import {CommonTLFModule} from '../../../common/common.module';
import { DetailCompanyComponent } from './pages/detail-company/detail-company.component';
import { GestionesocietaLemRoutingModule } from './gestionesocieta-lem-routing.module';





@NgModule({
  declarations: [
    InserimentoSocietaComponent,
    GestionesocietaComponent,
    SocietaListComponent,
    ConfirmModalComponent,
    DetailCompanyComponent,
  ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DynamicFormModule,
        CommonTLFModule,
        GestionesocietaLemRoutingModule
    ],
  exports: [
    InserimentoSocietaComponent,
  ]

})
export class GestioneSocietaModule { }
